export default "__VITE_ASSET__DLM7A2$h__"